import {
  DataEntityPresenterModel,
  FieldPresenterModel,
  FieldViewOptionValueTypeEnum,
} from '@osos/shared/types';
import { findFieldBasedOnShowOption } from '../utils';

export interface CardShape {
  mainTitle: FieldPresenterModel;
  subTitle: FieldPresenterModel;
  mainNumber: FieldPresenterModel;
}
export interface CardShapePicture extends CardShape {
  picture: FieldPresenterModel;
}
export interface KanbanShapePicture extends CardShape {
  picture: FieldPresenterModel;
  date: FieldPresenterModel;
  category: FieldPresenterModel;
  subCategory: FieldPresenterModel;
  relation: FieldPresenterModel;
}
export interface CalendarShapeDate extends CardShape {
  date: FieldPresenterModel;
}
export interface MiniCardShape extends CardShapePicture {
  date: FieldPresenterModel;
}
export abstract class CardView {
  constructor(
    private fields: FieldPresenterModel[] = [],
    private entity?: DataEntityPresenterModel,
  ) {}

  protected getMainTitle(): FieldPresenterModel {
    return this.searchForField(FieldViewOptionValueTypeEnum.showAsTitle);
  }
  protected getSubTitle(): FieldPresenterModel {
    return this.searchForField(FieldViewOptionValueTypeEnum.showAsSubTitle);
  }
  protected getPicture(): FieldPresenterModel {
    return this.searchForField(FieldViewOptionValueTypeEnum.showAsEntryPicture);
  }
  protected getDate(): FieldPresenterModel {
    return this.searchForField(FieldViewOptionValueTypeEnum.showAsMainDate);
  }
  protected getCategory(): FieldPresenterModel {
    return this.searchForField(FieldViewOptionValueTypeEnum.showAsCategory);
  }
  protected getSubCategory(): FieldPresenterModel {
    return this.searchForField(FieldViewOptionValueTypeEnum.showAsSubCategory);
  }
  protected getRelation(): FieldPresenterModel {
    return this.searchForField(
      FieldViewOptionValueTypeEnum.showAsRelationField,
    );
  }
  protected getMainNumber(): FieldPresenterModel {
    return this.searchForField(FieldViewOptionValueTypeEnum.showAsMainNumber);
  }
  private searchForField(
    type: FieldViewOptionValueTypeEnum,
  ): FieldPresenterModel {
    return findFieldBasedOnShowOption(this.fields, type);
  }
  abstract initKanbanShape(): void;
  abstract initMiniCardShape(): void;
  abstract getCardShape(): CardShape;
}

export class CardViewContent extends CardView {
  cardShape: CardShapePicture;
  constructor(fields: FieldPresenterModel[]) {
    super(fields);
    this.initKanbanShape();
  }
  initKanbanShape(): void {
    this.cardShape = {
      mainTitle: this.getMainTitle() || null,
      subTitle: this.getSubTitle() || null,
      picture: this.getPicture() || null,
      mainNumber: this.getMainNumber() || null,
    };
  }
  initMiniCardShape(): void {}
  getCardShape(): CardShape {
    return this.cardShape;
  }
}
export class CalendarViewContent extends CardView {
  calendarShape: CalendarShapeDate;
  constructor(fields: FieldPresenterModel[]) {
    super(fields);
    this.initKanbanShape();
  }
  initKanbanShape(): void {
    this.calendarShape = {
      mainTitle: this.getMainTitle(),
      subTitle: this.getSubTitle(),
      date: this.getDate(),
      mainNumber: this.getMainNumber() || null,
    };
  }
  initMiniCardShape(): void {}

  getCardShape(): CalendarShapeDate {
    return this.calendarShape;
  }
}

export class KanbanViewContent extends CardView {
  kanbanShape: KanbanShapePicture;
  constructor(fields: FieldPresenterModel[]) {
    super(fields);
    this.initKanbanShape();
  }
  initKanbanShape(): void {
    this.kanbanShape = {
      mainTitle: this.getMainTitle() || null,
      subTitle: this.getSubTitle() || null,
      picture: this.getPicture() || null,
      date: this.getDate() || null,
      category: this.getCategory() || null,
      subCategory: this.getSubCategory() || null,
      relation: this.getRelation() || null,
      mainNumber: this.getMainNumber() || null,
    };
  }
  initMiniCardShape(): void {}

  getCardShape(): KanbanShapePicture {
    return this.kanbanShape;
  }
}

export class CardViewSimple extends CardView {
  cardShape: CardShape;

  constructor(
    fields: FieldPresenterModel[],
    entity?: DataEntityPresenterModel,
  ) {
    super(fields, entity);
    this.initKanbanShape();
  }
  initMiniCardShape(): void {}

  initKanbanShape(): void {
    this.cardShape = {
      mainTitle: this.getMainTitle() || null,
      subTitle: this.getSubTitle() || null,
      mainNumber: this.getMainNumber() || null,
    };
  }

  getCardShape(): CardShape {
    return this.cardShape;
  }
}
export class MiniCardViewContent extends CardView {
  miniCardShape: MiniCardShape;
  constructor(fields: FieldPresenterModel[]) {
    super(fields);
    this.initMiniCardShape();
  }
  initKanbanShape(): void {}

  initMiniCardShape(): void {
    this.miniCardShape = {
      mainTitle: this.getMainTitle(),
      subTitle: this.getSubTitle(),
      date: this.getDate(),
      picture: this.getPicture(),
      mainNumber: this.getMainNumber() || null,
    };
  }
  getCardShape(): MiniCardShape {
    return this.miniCardShape;
  }
}
